/**
 * Root saga manages watcher lifecycle
 */
export default function* watchRibbonAdvancedSearch() {
  //   yield takeLatest(types.SAVE_ASSET_FULL, saveAssetSaga);
}
